var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',{staticStyle:{"overflow":"auto"}},[(_vm.data)?_c('DisplayJSON',{staticClass:"w-100 h-100",attrs:{"data":_vm.data,"pretty":true,"maxHeight":"100%;","maxWidth":"100%;"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }